import { environment } from './../../../../environments/environment';
import { DesignSystemModule } from 'src/theme/design-system/design-system.module';
import { BrMaskerModule } from 'br-mask';

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { BrandsPageRoutingModule } from './brands-routing.module';

import { BrandsPage } from './brands.page';
import { ComponentsModule } from 'src/app/components/components.module';
import { CloudinaryConfiguration, CloudinaryModule } from '@cloudinary/angular-5.x';
import { Cloudinary } from 'cloudinary-core';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    BrandsPageRoutingModule,
    BrMaskerModule,
    DesignSystemModule,
    ComponentsModule,
    CloudinaryModule.forRoot({Cloudinary}, { ...environment.cloudinary_config } as CloudinaryConfiguration),
  ],
  declarations: [BrandsPage]
})
export class BrandsPageModule {}
